<template>
  <div class="CoursesPage">
    <h1 class="Header">&bull;KURSER&bull;</h1>

    <div class="Courses">
      <CourseCard
        v-for="course in courses"
        :key="course.id"
        v-bind:course="course"
      ></CourseCard>
    </div>
  </div>
</template>

<script>
import CourseCard from '@/Components/CourseCard.vue';

export default {
  setup() {},
  data() {
    return {
      courses: [
        {
          id: 0,
          imageName: 'garden.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '3 Mar',
          lastSignUpDate: '01/12/12',
        },
        {
          id: 1,
          imageName: 'studio.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '7 Jun',
          lastSignUpDate: '01/12/12',
        },
        {
          id: 2,
          imageName: 'mountains-water.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '11 Jun',
          lastSignUpDate: '01/12/12',
        },
      ],
    };
  },
  components: {
    CourseCard,
  },
};
</script>

<style>
h1.Header {
  color: black;
  text-shadow: 0px 0px;
}

.Courses {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
}
</style>
